"use client";
import { useMemo, useRef, useState } from 'react';
import Image, { ImageProps } from 'next/image';
import { getYoutubeThumbnail, replaceStringVar } from '@/core/utils';
import { usePageWrapperData } from '@/providers/PageWrapperContext';

interface YoutubeThumbnailProps extends Omit<ImageProps, 'src' | 'width' | 'height'> {
  youtubeId: string;
  width?: number;
  height?: number;
}

export default function YoutubeThumbnail(props: YoutubeThumbnailProps) {
  const { youtubeId, className, alt, width, height } = props;
  const { labels: { ariaLabels } = {} } = usePageWrapperData();
  const ariaLabel = useMemo(() => replaceStringVar(ariaLabels?.playFallbackAlt, { name: youtubeId }), [youtubeId]);
  const [thumbnailUrl, setThumbnailUrl] = useState<string>(getYoutubeThumbnail(youtubeId));
  const isError = useRef(false);
  const handleError = () => {
    if (!isError.current) {
      setThumbnailUrl(getYoutubeThumbnail(youtubeId, true));
      isError.current = true;
    }
  }
  return (
    <Image
      className={className}
      src={thumbnailUrl}
      onError={handleError}
      width={width || 1280}
      height={height || 720}
      alt={alt || ariaLabel}
    />
  )
}